<template>
  <div>
    <!-- 1 -->
    <el-dialog :title="biaoTitle1 + '>' + biaoTitle2"
               v-if="dialogVisible1"
               :visible.sync="dialogVisible1"
               :fit="false"
               width="70%">
      <div class="nr">
        <table class="gridtable">
          <tr>
            <th colspan="10"
                style="font-size: calc(100vw * 20 / 1920);font-weight: 900;">主题一 ： 生态宜居</th>
          </tr>
          <tr>
            <th class="title_th">是否为古村落</th>
            <td colspan="2">
              <el-radio v-model="biao.historic_village"
                        label='1'
                        border>是</el-radio>
              <el-radio v-model="biao.historic_village"
                        label='0'
                        border>否</el-radio>
            </td>
            <td colspan="4">
              <el-radio v-model="biao.village_affirm"
                        label="1"
                        border>国家认定</el-radio>
              <el-radio v-model="biao.village_affirm"
                        label="2"
                        border>省级认定</el-radio>
              <el-radio v-model="biao.village_affirm"
                        label="3"
                        border>地方认定</el-radio>
            </td>
            <th rowspan="2"
                class="title_th">村落聚居时长</th>
            <td rowspan="2"
                colspan="2"
                class="title_th">{{ biao.history }}</td>
          </tr>
          <tr>
            <th class="title_th">是否为美丽乡村</th>
            <td colspan="2">
              <el-radio v-model="biao.beAutiful_country"
                        label="1"
                        border>是</el-radio>
              <el-radio v-model="biao.beAutiful_country"
                        label="0"
                        border>否</el-radio>
            </td>
            <td colspan="4">
              <el-radio v-model="biao.country_affirm"
                        label="1"
                        border>国家认定</el-radio>
              <el-radio v-model="biao.country_affirm"
                        label="2"
                        border>省级认定</el-radio>
              <el-radio v-model="biao.country_affirm"
                        label="3"
                        border>地方认定</el-radio>
            </td>
          </tr>
          <tr>
            <th rowspan="2">山</th>
            <th colspan="2">代表性 山脉\山峰名称</th>
            <td colspan="7">{{ biao.mountain }}</td>
          </tr>
          <tr>
            <th colspan="2">代表性图片</th>
            <td colspan="7"
                class="table_img">
              <img v-for="(item, index) in biao.mountain_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="9">水</th>
            <th rowspan="3"
                colspan="2">代表性 河流名称</th>
            <td colspan="7">
              <el-radio v-model="biao.river_type"
                        label="1"
                        border>自然河流</el-radio>
              <el-radio v-model="biao.river_type"
                        label="2"
                        border>人工水道</el-radio>
            </td>
          </tr>
          <tr>
            <th>名称</th>
            <td colspan="6">{{ biao.river }}</td>
          </tr>
          <tr>
            <td colspan="7"
                class="table_img">
              <img v-for="(item, index) in biao.river_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="3"
                colspan="2">代表性 湖泊/池塘名称</th>
            <td colspan="7">
              <el-radio v-model="biao.lakes_type"
                        label="1"
                        border>自然水体</el-radio>
              <el-radio v-model="biao.lakes_type"
                        label="2"
                        border>人工水体</el-radio>
            </td>
          </tr>
          <tr>
            <th>名称</th>
            <td colspan="6">{{ biao.lakes}}</td>
          </tr>
          <tr>
            <td colspan="7"
                class="table_img">
              <img v-for="(item, index) in biao.lakes_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="3"
                colspan="2">代表性 水源名称</th>
            <td colspan="7">
              <el-radio v-model="biao.source_type"
                        label="1"
                        border>古水井</el-radio>
              <el-radio v-model="biao.source_type"
                        label="2"
                        border>山泉</el-radio>
              <el-radio v-model="biao.source_type"
                        label="3"
                        border>温泉</el-radio>
            </td>
          </tr>
          <tr>
            <th>名称</th>
            <td colspan="6">{{ biao.source }}</td>
          </tr>
          <tr>
            <td colspan="7"
                class="table_img">
              <img v-for="(item, index) in biao.source_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="6">特色景观</th>
            <th colspan="2">景观名称</th>
            <td colspan="7">{{ biao.scenic_name }}</td>
          </tr>
          <tr>
            <th rowspan="4">已开发为旅游景区</th>
            <td rowspan="3"
                style="width: 10%;">
              <el-radio v-model="biao.tourist_scenic"
                        label="1"
                        border>是</el-radio>
            </td>
            <th colspan="1">旅游路线</th>
            <td colspan="6">{{ biao.scenic_path }}</td>
          </tr>
          <tr>
            <th>景区级别</th>
            <td colspan="6">
              <el-radio v-model="biao.scenic_rank"
                        label="4"
                        border>县</el-radio>
              <el-radio v-model="biao.scenic_rank"
                        label="3"
                        border>市</el-radio>
              <el-radio v-model="biao.scenic_rank"
                        label="2"
                        border>省</el-radio>
              <el-radio v-model="biao.scenic_rank"
                        label="1"
                        border>国</el-radio>
            </td>
          </tr>
          <tr>
            <th>村民开发意愿</th>
            <td colspan="6">
              <el-radio v-model="biao.intention"
                        label="3"
                        border>非常强烈</el-radio>
              <el-radio v-model="biao.intention"
                        label="2"
                        border>强烈</el-radio>
              <el-radio v-model="biao.intention"
                        label="1"
                        border>一般</el-radio>
              <el-radio v-model="biao.intention"
                        label="0"
                        border>不愿意</el-radio>
            </td>
          </tr>
          <tr>
            <td colspan="8">
              <el-radio v-model="biao.tourist_scenic"
                        label="0"
                        border>否</el-radio>
            </td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.scenic_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="3">生态宜居大事记</th>
            <th colspan="1">日期</th>
            <th colspan="4">事件、活动</th>
            <th colspan="4">影响</th>
          </tr>
          <tr>
            <td colspan="1">{{ biao.event_date }}</td>
            <td colspan="4">{{ biao.event_name }}</td>
            <td colspan="4">{{ biao.event_influence }}</td>
          </tr>
          <tr>
            <th colspan="1">现场照片、视频</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.event_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>样本地址</th>
            <td colspan="9">{{ biao.sample_site }}</td>
          </tr>
          <tr>
            <th>调研人</th>
            <td colspan="9">{{ biao.research_name }}</td>
          </tr>
          <tr>
            <th>调研时间</th>
            <td colspan="9">{{ biao.research_date }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>

    <!-- 2 -->
    <el-dialog :title="biaoTitle1 + '>' + biaoTitle2"
               v-if="dialogVisible2"
               :visible.sync="dialogVisible2"
               width="70%">
      <div class="nr">
        <table class="gridtable">
          <tr>
            <th colspan="10"
                style="font-size: calc(100vw * 20 / 1920);font-weight: 900;">主题二 ： 产业兴旺</th>
          </tr>
          <tr>
            <th class="title_th">主要收入来源</th>
            <td colspan="9">{{ biao.primary_income }}</td>
          </tr>
          <tr>
            <th>次要收入来源</th>
            <td colspan="9">{{ biao.minor_income }}</td>
          </tr>
          <tr>
            <th rowspan="2">种植业</th>
            <th>主要粮食作物名称</th>
            <td colspan="3">{{ biao.staple_crop }}</td>
            <th>主要经济作物名称</th>
            <td colspan="4">{{ biao.industrial_crop }}</td>
          </tr>
          <tr>
            <td colspan="4"
                class="table_img">
              <img v-for="(item, index) in biao.staple_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
            <td colspan="5"
                class="table_img">
              <img v-for="(item, index) in biao.industrial_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">传统手工业</th>
            <th>产品名称</th>
            <td colspan="8">{{ biao.craft_name }}</td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.craft_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="3">电子商业</th>
            <th>农村电商</th>
            <td colspan="8">
              <el-radio v-model="biao.electronic"
                        label="1"
                        border>有</el-radio>
              <el-radio v-model="biao.electronic"
                        label="0"
                        border>无</el-radio>
            </td>
          </tr>
          <tr>
            <th>主要电商平台名称</th>
            <td colspan="3">{{ biao.electronic_name }}</td>
            <th>主要售卖产品</th>
            <td colspan="4">{{ biao.electronic_img }}</td>
          </tr>
          <tr>
            <th>电商网址</th>
            <td colspan="8">{{ biao.electronic_url }}</td>
          </tr>
          <tr>
            <th rowspan="3">田园综合体（含农家乐）</th>
            <th>田园综合体</th>
            <td colspan="8">
              <el-radio v-model="biao.synthesis"
                        label="1"
                        border>有</el-radio>
              <el-radio v-model="biao.synthesis"
                        label="0"
                        border>无</el-radio>
            </td>
          </tr>
          <tr>
            <th>名称</th>
            <td colspan="8">{{ biao.synthesis_name }}</td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.synthesis_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="5">产业工具（可填多项）</th>
            <th rowspan="2">传统农业生产工具</th>
            <th>名称</th>
            <td colspan="2">{{ biao.farm_tools }}</td>
            <th>用途</th>
            <td colspan="4">{{ biao.farm_use }}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.farm_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">传统手工业生产工具</th>
            <th>名称</th>
            <td colspan="2">{{ biao.hand_tools }}</td>
            <th>用途</th>
            <td colspan="4">{{ biao.hand_use }}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.hand_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>现代农机</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.agricultural_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="3">村属特色品牌（含口碑产品）</th>
            <th>是否注册商标</th>
            <td colspan="2">
              <el-radio v-model="biao.feature_brand"
                        label="1"
                        border>是</el-radio>
              <el-radio v-model="biao.feature_brand"
                        label="0"
                        border>否</el-radio>
            </td>
            <th>品牌名称</th>
            <td colspan="5">{{ biao.feature_name }}</td>
          </tr>
          <tr>
            <th>影响区域范围</th>
            <td colspan="8">
              <el-radio v-model="biao.feature_scope"
                        label="4"
                        border>乡域</el-radio>
              <el-radio v-model="biao.feature_scope"
                        label="3"
                        border>县域</el-radio>
              <el-radio v-model="biao.feature_scope"
                        label="2"
                        border>省域</el-radio>
              <el-radio v-model="biao.feature_scope"
                        label="1"
                        border>全国</el-radio>
            </td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.specialty_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">特色产品</th>
            <th class="nr_th">产品名称</th>
            <td colspan="3">{{ biao.specialty_name }}</td>
            <th>产品历史</th>
            <td colspan="1">{{ biao.specialty_history }}</td>
            <th>非遗产品</th>
            <td colspan="2">
              <el-radio v-model="biao.heritage"
                        label="1"
                        border>是</el-radio>
              <el-radio v-model="biao.heritage"
                        label="0"
                        border>否</el-radio>
            </td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.feature_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>产业遗迹</th>
            <td colspan="9">{{ biao.ruins }}</td>
          </tr>
          <tr>
            <th rowspan="3">产业兴旺大事记</th>
            <th>日期</th>
            <th colspan="4">事件、活动</th>
            <th colspan="4">影响</th>
          </tr>
          <tr>
            <td colspan="1">{{ biao.event_date }}</td>
            <td colspan="4">{{ biao.event_name }}</td>
            <td colspan="4">{{ biao.event_influence }}</td>
          </tr>
          <tr>
            <th colspan="1">现场照片、视频</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.event_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>样本地址</th>
            <td colspan="9">{{ biao.sample_site }}</td>
          </tr>
          <tr>
            <th>调研人</th>
            <td colspan="9">{{ biao.research_name }}</td>
          </tr>
          <tr>
            <th>调研时间</th>
            <td colspan="9">{{ biao.research_date }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>

    <!-- 3 -->
    <el-dialog :title="biaoTitle1 + '>' + biaoTitle2"
               v-if="dialogVisible3"
               :visible.sync="dialogVisible3"
               width="70%">
      <div class="nr">
        <table class="gridtable">
          <tr>
            <th colspan="10"
                style="font-size: calc(100vw * 20 / 1920);font-weight: 900;">主题三 ： 乡风文明</th>
          </tr>
          <tr>
            <th class="title_th">主体名族</th>
            <td colspan="2">{{biao.nation}}</td>
            <th>少数名族</th>
            <td colspan="6">{{biao.nation_minority}}</td>
          </tr>
          <tr>
            <th>村落布局</th>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.layout_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="7">民俗文化活动</th>
            <th rowspan="2"
                class="title_th">传统民族体育活动</th>
            <th>名称</th>
            <td colspan="7">{{biao.festival_name}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.festival_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">传统民族庆典活动</th>
            <th class="title_th">名称</th>
            <td colspan="3">{{biao.celebration_name}}</td>
            <th>举办日期</th>
            <td colspan="3">{{biao.celebration_date}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.celebration_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">特色民族传统节日</th>
            <th>名称</th>
            <td colspan="3">{{biao.feature_name}}</td>
            <th class="title_th">举办日期</th>
            <td colspan="3">{{biao.feature_date}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.feature_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>族祭、家祭</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.fete_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="6">特色工具</th>
            <th rowspan="2">礼器</th>
            <th>名称</th>
            <td colspan="3">{{biao.sacrificial_name}}</td>
            <th class="title_th">用途</th>
            <td colspan="3">{{biao.sacrificial_effect}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.sacrificial_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">生活用具</th>
            <th>名称</th>
            <td colspan="3">{{biao.utensil_name}}</td>
            <th>用途</th>
            <td colspan="3">{{biao.utensil_effect}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.utensil_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">文娱用具</th>
            <th>名称</th>
            <td colspan="3">{{biao.recreation_name}}</td>
            <th>用途</th>
            <td colspan="3">{{biao.recreation_effect}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.recreation_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="6">特色风味</th>
            <th rowspan="2">主食</th>
            <th>名称</th>
            <td colspan="3">{{biao.food_name}}</td>
            <th>制作原料</th>
            <td colspan="3">{{biao.food_materials}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.food_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">特色小吃</th>
            <th>名称</th>
            <td colspan="3">{{biao.snack_name}}</td>
            <th>制作原料</th>
            <td colspan="3">{{biao.snack_materials}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.snack_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">特色饮料</th>
            <th>名称</th>
            <td colspan="3">{{biao.drinks_name}}</td>
            <th>制作原料</th>
            <td colspan="3">{{biao.drinks_materials}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.drinks_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2">特色服饰</th>
            <th>饰品名称</th>
            <td colspan="4">{{biao.ornament_name}}</td>
            <th>服装名称</th>
            <td colspan="3">{{biao.clothing_name}}</td>
          </tr>
          <tr>
            <td colspan="5"
                class="table_img">
              <img v-for="(item, index) in biao.ornament_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
            <td colspan="4"
                class="table_img">
              <img v-for="(item, index) in biao.clothing_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="12">特色建筑</th>
            <th>宗祠</th>
            <th>名称</th>
            <td colspan="4">{{biao.temple_name}}</td>
            <th>数量</th>
            <td colspan="2">{{biao.temple_quantity}}</td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.temple_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>牌楼</th>
            <th>名称</th>
            <td colspan="4">{{biao.play_name}}</td>
            <th>数量</th>
            <td colspan="2">{{biao.play_quantity}}</td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.play_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>神祇</th>
            <th>名称</th>
            <td colspan="4">{{biao.religion_name}}</td>
            <th>数量</th>
            <td colspan="2">{{biao.religion_quantity}}</td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.religion_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>独栋外观</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.facade_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>院落布局</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.courtyard_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>堂屋</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.living_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>卧室</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.bedroom_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>厨房</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.kitchen_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>餐厅</th>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.canteen_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="3">非遗</th>
            <th>名称</th>
            <td colspan="3">{{biao.relic_name}}</td>
            <th>级别</th>
            <td colspan="4">
              <el-radio v-model="biao.relic_rank"
                        label="4"
                        border>乡域</el-radio>
              <el-radio v-model="biao.relic_rank"
                        label="3"
                        border>县域</el-radio>
              <el-radio v-model="biao.relic_rank"
                        label="2"
                        border>省域</el-radio>
              <el-radio v-model="biao.relic_rank"
                        label="1"
                        border>全国</el-radio>
            </td>
          </tr>
          <tr>
            <th>传承人姓名</th>
            <td colspan="2">{{biao.inheritor_name}}</td>
            <th>性别</th>
            <td colspan="2">{{biao.inheritor_sex}}</td>
            <th>年龄</th>
            <td colspan="2">{{biao.inheritor_age}}</td>
          </tr>
          <tr>
            <td colspan="9"
                class="table_img">
              <img v-for="(item, index) in biao.inheritor_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="3">乡风文明大事记</th>
            <th colspan="2">日期</th>
            <th colspan="3">事件、活动</th>
            <th colspan="4">影响</th>
          </tr>
          <tr>
            <td colspan="2">{{biao.event_date}}</td>
            <td colspan="3">{{biao.event_name}}</td>
            <td colspan="4">{{biao.event_influence}}</td>
          </tr>
          <tr>
            <th>危房</th>
            <td colspan="8">{{biao.dangerous_building}}</td>
          </tr>
          <tr>
            <th>样本地址</th>
            <td colspan="9">{{biao.sample_site}}</td>
          </tr>
          <tr>
            <th>调研人</th>
            <td colspan="9">{{biao.research_name}}</td>
          </tr>
          <tr>
            <th>调研时间</th>
            <td colspan="9">{{biao.research_date}}</td>
          </tr>
        </table>
      </div>
    </el-dialog>

    <!-- 4 -->
    <el-dialog :title="biaoTitle1 + '>' + biaoTitle2"
               v-if="dialogVisible4"
               :visible.sync="dialogVisible4"
               width="70%">
      <div class="nr">
        <table class="gridtable">
          <tr>
            <th colspan="10"
                style="font-size: calc(100vw * 20 / 1920);font-weight: 900;">主题四 ： 治理有效</th>
          </tr>
          <tr>
            <th rowspan="10"
                class="title_th">民俗文化活动</th>
            <th class="title_th">村办幼儿园</th>
            <td colspan="3">
              <el-radio v-model="biao.kindergarten"
                        label="0"
                        border>无</el-radio>
              <el-radio v-model="biao.kindergarten"
                        label="1"
                        border>有</el-radio>
            </td>
            <th class="title_th">村办中小学</th>
            <td colspan="4">
              <el-radio v-model="biao.school"
                        label="0"
                        border>无</el-radio>
              <el-radio v-model="biao.school"
                        label="1"
                        border>有</el-radio>
            </td>
          </tr>
          <tr>
            <th class="title_th">开设班级</th>
            <td colspan="3">{{biao.kindergarten_class}}</td>
            <th class="title_th">开设班级</th>
            <td colspan="4">{{biao.school_class}}</td>
          </tr>
          <tr>
            <td colspan="4"
                class="table_img">
              <img v-for="(item, index) in biao.kindergarten_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
            <td colspan="5"
                class="table_img">
              <img v-for="(item, index) in biao.school_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="2"
                class="title_th">村办其他教育机构</th>
            <th class="title_th">名称</th>
            <td colspan="2">{{biao.educational_name}}</td>
            <th class="title_th">用途</th>
            <td colspan="4">{{biao.educational_use}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.educational_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th">教育从业人员总数</th>
            <td colspan="3">{{biao.teacher_quantity}}</td>
            <th class="title_th">在读学生总数</th>
            <td colspan="4">{{biao.student_quantity}}</td>
          </tr>
          <tr>
            <th class="title_th">在读大学生数</th>
            <td colspan="3">{{biao.university_quantity}}</td>
            <th class="title_th">在读中小学生数</th>
            <td colspan="4">{{biao.middle_quantity}}</td>
          </tr>
          <tr>
            <th class="title_th">专科以上学历人才输送</th>
            <td colspan="3">{{biao.university_transport}}</td>
            <th rowspan="3"
                class="title_th">高中（中专）以上学历村民数</th>
            <td colspan="4"
                rowspan="3">{{biao.high_school}}</td>
          </tr>
          <tr>
            <th class="title_th">本科以上学历人才输送</th>
            <td colspan="3">{{biao.education_higher}}</td>
          </tr>
          <tr>
            <th class="title_th">职教</th>
            <td colspan="3">{{biao.vocational_education}}</td>
          </tr>
          <tr>
            <th rowspan="4"
                class="title_th">医疗卫生</th>
            <th rowspan="3"
                class="title_th">卫生室建设情况</th>
            <td colspan="3">{{biao.clinic_construction}}</td>
            <th class="title_th">常驻医务人员总数</th>
            <td colspan="4">{{biao.medic}}</td>
          </tr>
          <tr>
            <td colspan="8">{{biao.separate}}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.hospital_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th">公众卫生</th>
            <th class="title_th">公共厕所</th>
            <td colspan="7">
              <el-radio v-model="biao.sanitation"
                        label="0"
                        border>无</el-radio>
              <el-radio v-model="biao.sanitation"
                        label="1"
                        border>有</el-radio>
            </td>
          </tr>
          <tr>
            <th rowspan="2">民生保证</th>
            <th>日期</th>
            <th colspan="4">事件、活动</th>
            <th colspan="4">结果（例新建学校等）</th>
          </tr>
          <tr>
            <td>{{ biao.event_date }}</td>
            <td colspan="4">{{ biao.event_name }}</td>
            <td colspan="4">{{ biao.event_influence }}</td>
          </tr>
          <tr>
            <th>样本地址</th>
            <td colspan="9">{{ biao.sample_site }}</td>
          </tr>
          <tr>
            <th>调研人</th>
            <td colspan="9">{{ biao.research_name }}</td>
          </tr>
          <tr>
            <th>调研时间</th>
            <td colspan="9">{{ biao.research_date }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>

    <!-- 5 -->
    <el-dialog :title="biaoTitle1 + '>' + biaoTitle2"
               v-if="dialogVisible5"
               :visible.sync="dialogVisible5"
               width="70%">
      <div class="nr">
        <table class="gridtable">
          <tr>
            <th colspan="10"
                style="font-size: calc(100vw * 20 / 1920);font-weight: 900;">主题五 ： 生活富裕</th>
          </tr>
          <tr>
            <th rowspan="8"
                class="title_th">物质富裕</th>
            <th rowspan="8"
                class="title_th">公共设施</th>
            <th class="title_th"
                rowspan="2">文化设施</th>
            <th class="title_th">阅览室</th>
            <td>{{ biao.reading_room }}</td>
            <th class="title_th">宣传栏</th>
            <td>{{ biao.bulletin_board }}</td>
            <th class="title_th">是否通宽带网络</th>
            <td colspan="2">
              <el-radio v-model="biao.ethernet"
                        label="1"
                        border>是</el-radio>
              <el-radio v-model="biao.ethernet"
                        label="0"
                        border>否</el-radio>
            </td>
          </tr>
          <tr>
            <td colspan="7"
                class="table_img">
              <img v-for="(item, index) in biao.reading_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th"
                rowspan="2">休闲设施</th>
            <th class="title_th">凉亭数</th>
            <td>{{ biao.pavilion_quantity }}</td>
            <th class="title_th">戏台</th>
            <td>{{ biao.stage_quantity }}</td>
            <th class="title_th">景观回廊</th>
            <td colspan="2">{{ biao.ambulatory_quantity }}</td>
          </tr>
          <tr>
            <td colspan="7"
                class="table_img">
              <img v-for="(item, index) in biao.pavilion_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th"
                rowspan="2">健身设施</th>
            <th class="title_th">健身器材</th>
            <td>{{ biao.fitnesse_quipment }}</td>
            <th class="title_th">棋牌室</th>
            <td>{{ biao.chess_card }}</td>
            <th class="title_th">篮球场</th>
            <td colspan="2">{{ biao.basketball_court }}</td>
          </tr>
          <tr>
            <td colspan="7"
                class="table_img">
              <img v-for="(item, index) in biao.fitnesse_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th"
                rowspan="2">便利设施</th>
            <th class="title_th">路灯</th>
            <td>{{ biao.street_lamp }}</td>
            <th class="title_th">小卖部</th>
            <td>{{ biao.retail_section }}</td>
            <th class="title_th">是否通自来水</th>
            <td colspan="2">
              <el-radio v-model="biao.running_water"
                        label="1"
                        border>是</el-radio>
              <el-radio v-model="biao.running_water"
                        label="0"
                        border>否</el-radio>
            </td>
          </tr>
          <tr>
            <td colspan="7"
                class="table_img">
              <img v-for="(item, index) in biao.street_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="6"
                class="title_th">精神富裕</th>
            <th class="title_th"
                rowspan="2">主要文化活动</th>
            <th class="title_th">名称</th>
            <td colspan="3">{{ biao.activity_name }}</td>
            <th class="title_th">年均举办频率</th>
            <td colspan="3">{{ biao.activity_frequency }}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.activity_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th"
                rowspan="2">传统体育活动</th>
            <th class="title_th">名称</th>
            <td colspan="3">{{ biao.sports_name }}</td>
            <th class="title_th">年均举办频率</th>
            <td colspan="3">{{ biao.sports_frequency }}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.sports_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th"
                rowspan="2">传统节日庆典</th>
            <th class="title_th">名称</th>
            <td colspan="3">{{ biao.celebration_name }}</td>
            <th class="title_th">年均举办频率</th>
            <td colspan="3">{{ biao.celebration_frequency }}</td>
          </tr>
          <tr>
            <td colspan="8"
                class="table_img">
              <img v-for="(item, index) in biao.celebration_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th rowspan="3">村庄建设</th>
            <th>日期</th>
            <th colspan="4">事件、活动</th>
            <th colspan="4">影响</th>
          </tr>
          <tr>
            <td>{{ biao.event_date }}</td>
            <td colspan="4">{{ biao.event_name }}</td>
            <td colspan="4">{{ biao.event_influence }}</td>
          </tr>
          <tr>
            <th colspan="1">现场照片、视频</th>
            <td class="table_img"
                colspan="8">
              <img v-for="(item, index) in biao.event_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th>样本地址</th>
            <td colspan="9">{{ biao.sample_site }}</td>
          </tr>
          <tr>
            <th>调研人</th>
            <td colspan="9">{{ biao.research_name }}</td>
          </tr>
          <tr>
            <th>调研时间</th>
            <td colspan="9">{{ biao.research_date }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>

    <!-- 6 -->
    <el-dialog :visible.sync="dialogVisible6"
               v-if="dialogVisible6"
               width="70%">
      <div class="nr">
        <table class="gridtable">
          <tr>
            <th colspan="5"
                style="font-size: calc(100vw * 20 / 1920);font-weight: 900;">主题六 ： 当地故事</th>
          </tr>
          <tr>
            <th class="title_th"
                rowspan="4">红色传承</th>
            <th class="title_th">故事名称</th>
            <td>{{biao.inherit_name}}</td>
            <th class="title_th">主人公名字</th>
            <td>{{biao.inherit_figure}}</td>
          </tr>
          <tr>
            <th class="title_th">所处时间</th>
            <td>{{biao.inherit_day}}</td>
            <th class="title_th">地点</th>
            <td>{{biao.inherit_place}}</td>
          </tr>
          <tr>
            <td colspan="4">{{biao.inherit_content}}</td>
          </tr>
          <tr>
            <td colspan="4"
                class="table_img">
              <img v-for="(item, index) in biao.inherit_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th"
                rowspan="4">团结故事</th>
            <th class="title_th">故事名称</th>
            <td>{{biao.unity_name}}</td>
            <th class="title_th">主人公名字</th>
            <td>{{biao.unity_figure}}</td>
          </tr>
          <tr>
            <th class="title_th">所处时间</th>
            <td>{{biao.unity_day}}</td>
            <th class="title_th">地点</th>
            <td>{{biao.unity_place}}</td>
          </tr>
          <tr>
            <td colspan="4">{{biao.unity_content}}</td>
          </tr>
          <tr>
            <td colspan="4"
                class="table_img">
              <img v-for="(item, index) in biao.unity_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
          <tr>
            <th class="title_th"
                rowspan="4">民间传说</th>
            <th class="title_th">故事名称</th>
            <td>{{biao.folklore_name}}</td>
            <th class="title_th">主人公名字</th>
            <td>{{biao.folklore_figure}}</td>
          </tr>
          <tr>
            <th class="title_th">所处时间</th>
            <td>{{biao.folklore_day}}</td>
            <th class="title_th">地点</th>
            <td>{{biao.folklore_place}}</td>
          </tr>
          <tr>
            <td colspan="4">{{biao.folklore_content}}</td>
          </tr>
          <tr>
            <td colspan="4"
                class="table_img">
              <img v-for="(item, index) in biao.folklore_img"
                   :key="index"
                   :src="item"
                   alt="">
            </td>
          </tr>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import bus from '../utils/bus.js'

export default {
  data () {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,

      biaoTitle1: '',
      biaoTitle2: '',


      biao: {},

    };
  },
  mounted () {
    this.$bus.$on("mzgsBiao", (data) => {
      this.biao = data
      this.dialogVisible6 = true
      this.biao.inherit_img = this.biao.inherit_img.split('、')
      this.biao.unity_img = this.biao.unity_img.split('、')
      this.biao.folklore_img = this.biao.folklore_img.split('、')
    }),

      this.$bus.$on("feiyiBiao", (data) => {
        this.biao = data
        this.dialogVisible3 = true
        this.biao.layout_img = this.biao.layout_img.split('、')
        this.biao.festival_img = this.biao.festival_img.split('、')
        this.biao.celebration_img = this.biao.celebration_img.split('、')
        this.biao.feature_img = this.biao.feature_img.split('、')
        this.biao.fete_img = this.biao.fete_img.split('、')
        this.biao.sacrificial_img = this.biao.sacrificial_img.split('、')
        this.biao.utensil_img = this.biao.utensil_img.split('、')
        this.biao.recreation_img = this.biao.recreation_img.split('、')
        this.biao.food_img = this.biao.food_img.split('、')
        this.biao.snack_img = this.biao.snack_img.split('、')
        this.biao.drinks_img = this.biao.drinks_img.split('、')
        this.biao.ornament_img = this.biao.ornament_img.split('、')
        this.biao.clothing_img = this.biao.clothing_img.split('、')
        this.biao.temple_img = this.biao.temple_img.split('、')
        this.biao.play_img = this.biao.play_img.split('、')
        this.biao.religion_img = this.biao.religion_img.split('、')
        this.biao.facade_img = this.biao.facade_img.split('、')
        this.biao.courtyard_img = this.biao.courtyard_img.split('、')
        this.biao.living_img = this.biao.living_img.split('、')
        this.biao.bedroom_img = this.biao.bedroom_img.split('、')
        this.biao.kitchen_img = this.biao.kitchen_img.split('、')
        this.biao.canteen_img = this.biao.canteen_img.split('、')
        this.biao.inheritor_img = this.biao.inheritor_img.split('、')
      }),

      this.$bus.$on("biaoData", (data) => {
        this.biaoTitle1 = data.region
        var burg_id = data.burg_id
        console.log(burg_id, 'llllll');

        if (this.$route.path == '/styj')
        {
          // console.log('生态宜居');
          this.getBiaoList(burg_id)
          this.dialogVisible1 = true
        } else if (this.$route.path == '/cyxw')
        {
          // console.log('产业兴旺');
          // this.dialogVisible6 = true
          this.getBiaoList(burg_id)
          this.dialogVisible2 = true
        } else if (this.$route.path == '/xfwm' || this.$route.path == '/mjgs')
        {
          // console.log('乡风文明');
          this.getBiaoList(burg_id)
          this.dialogVisible3 = true
        } else if (this.$route.path == '/zlyx')
        {
          // console.log('治理有效');
          this.getBiaoList(burg_id)
          this.dialogVisible4 = true
        } else if (this.$route.path == '/shfy')
        {
          // console.log('生活富裕');
          this.getBiaoList(burg_id)
          this.dialogVisible5 = true
        }
      });
  },
  methods: {
    getBiaoList (data) {
      console.log(data);
      this.$http.get('api/ssm/Api/listBurg_id', {
        params: { Burg_id: data },
      }).then((r) => {
        console.log(r.data, '数据');
        this.biaoTitle2 = r.data.slist.region_burg
        if (this.$route.path == '/styj')
        {
          console.log('生态宜居');
          this.biao = r.data.alist
          if (this.biao == null)
          {
            this.biao = ' '
          }
          console.log(this.biao, 'ssssssss');
          this.biao.river_img = this.biao.river_img.split('、')
          this.biao.lakes_img = this.biao.lakes_img.split('、')
          this.biao.source_img = this.biao.source_img.split('、')
          this.biao.scenic_img = this.biao.scenic_img.split('、')
          this.biao.event_img = this.biao.event_img.split('、')
          this.biao.mountain_img = this.biao.mountain_img.split('、')
          console.log(this.biao, 'hhhhhhhh');
        } else if (this.$route.path == '/cyxw')
        {
          console.log('产业兴旺');
          this.biao = r.data.blist
          if (this.biao == null)
          {
            this.biao = ' '
          }
          console.log(r.data, 'ssssssss');
          this.biao.staple_img = this.biao.staple_img.split('、')
          this.biao.industrial_img = this.biao.industrial_img.split('、')
          this.biao.craft_img = this.biao.craft_img.split('、')
          this.biao.synthesis_img = this.biao.synthesis_img.split('、')
          this.biao.farm_img = this.biao.farm_img.split('、')
          this.biao.hand_img = this.biao.hand_img.split('、')
          this.biao.agricultural_img = this.biao.agricultural_img.split('、')
          this.biao.feature_img = this.biao.feature_img.split('、')
          this.biao.specialty_img = this.biao.specialty_img.split('、')
          this.biao.event_img = this.biao.event_img.split('、')
          console.log(this.biao, 'hhhhhhhh');
        } else if (this.$route.path == '/xfwm')
        {
          // console.log('乡风文明');
          this.biao = r.data.clist
          if (this.biao == null)
          {
            this.biao = ' '
          }
          console.log(r.data.clist, 'ssssssss');
          this.biao.layout_img = this.biao.layout_img.split('、')
          this.biao.festival_img = this.biao.festival_img.split('、')
          this.biao.celebration_img = this.biao.celebration_img.split('、')
          this.biao.feature_img = this.biao.feature_img.split('、')
          this.biao.fete_img = this.biao.fete_img.split('、')
          this.biao.sacrificial_img = this.biao.sacrificial_img.split('、')
          this.biao.utensil_img = this.biao.utensil_img.split('、')
          this.biao.recreation_img = this.biao.recreation_img.split('、')
          this.biao.food_img = this.biao.food_img.split('、')
          this.biao.snack_img = this.biao.snack_img.split('、')
          this.biao.drinks_img = this.biao.drinks_img.split('、')
          this.biao.ornament_img = this.biao.ornament_img.split('、')
          this.biao.clothing_img = this.biao.clothing_img.split('、')
          this.biao.temple_img = this.biao.temple_img.split('、')
          this.biao.play_img = this.biao.play_img.split('、')
          this.biao.religion_img = this.biao.religion_img.split('、')
          this.biao.facade_img = this.biao.facade_img.split('、')
          this.biao.courtyard_img = this.biao.courtyard_img.split('、')
          this.biao.living_img = this.biao.living_img.split('、')
          this.biao.bedroom_img = this.biao.bedroom_img.split('、')
          this.biao.kitchen_img = this.biao.kitchen_img.split('、')
          this.biao.canteen_img = this.biao.canteen_img.split('、')
          this.biao.inheritor_img = this.biao.inheritor_img.split('、')
          console.log(this.biao, 'hhhhhhhh');
        } else if (this.$route.path == '/zlyx')
        {
          // console.log('治理有效');
          this.biao = r.data.dlist
          if (this.biao == null)
          {
            this.biao = ' '
          }
          this.biao.kindergarten_img = this.biao.kindergarten_img.split('、')
          this.biao.school_img = this.biao.school_img.split('、')
          this.biao.educational_img = this.biao.educational_img.split('、')
          this.biao.hospital_img = this.biao.hospital_img.split('、')

          console.log(this.biao);
        } else if (this.$route.path == '/shfy')
        {
          this.biao = r.data.elist
          if (this.biao == null)
          {
            this.biao = ' '
          }
          this.biao.reading_img = this.biao.reading_img.split('、')
          // this.biao.bulletin_img = this.biao.bulletin_img.split('、')
          this.biao.ethernet_img = this.biao.ethernet_img.split('、')
          this.biao.pavilion_img = this.biao.pavilion_img.split('、')
          this.biao.stage_img = this.biao.stage_img.split('、')
          this.biao.ambulatory_img = this.biao.ambulatory_img.split('、')
          this.biao.fitnesse_img = this.biao.fitnesse_img.split('、')
          this.biao.chess_img = this.biao.chess_img.split('、')
          this.biao.basketball_img = this.biao.basketball_img.split('、')
          this.biao.street_img = this.biao.street_img.split('、')
          this.biao.running_img = this.biao.running_img.split('、')
          this.biao.activity_img = this.biao.activity_img.split('、')
          this.biao.sports_img = this.biao.sports_img.split('、')
          this.biao.celebration_img = this.biao.celebration_img.split('、')
          this.biao.event_img = this.biao.event_img.split('、')

          console.log(this.biao);
        }
      })
    },
    handleClose (done) {
      done()
    }
  },
};
</script>

<style scoped lang="less">
/deep/ .nr {
  table.gridtable {
    // margin: 0 auto;
    // width: fit-content;
    width: 100%;
    font-family: verdana, arial, sans-serif;
    color: #333333;
    border-width: 1px;
    border-color: #666666;
    border-collapse: collapse;
    text-align: center;
    // table-layput: fixed;
    // word-wrap: break-wrod;
    // word-break: break-all;
    table-layout: fixed;
    word-wrap: break-word;
    word-break: break-all;

    .title_th {
      width: 10%;
    }

    .nr_th {
      width: 10%;
    }

    .table_img {
      // column-count: 4; //想要排成的列数

      // column-gap: 0.5vh;
      img {
        -webkit-column-break-inside: avoid;
        width: 20%;
        margin: 1%;
      }
    }
  }

  table.gridtable th {
    font-weight: 900;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    background-color: #dedede;
    text-align: center;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    background-color: #ffffff;
    height: 4vh;
  }
}

/deep/ .el-radio {
  margin-right: 1vh;
}
</style>